export const comments_4504522 = {"data":{"data":[],"links":{}}}